export default __webpack_public_path__ + "static/media/zoom-out.e92f1c7f.svg";